import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/emotka.png'


const _hoisted_1 = { class: "profile" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Profil", -1)
const _hoisted_3 = { class: "profile__logo" }
const _hoisted_4 = { class: "profile__nick" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "profile__data"
}
const _hoisted_7 = { class: "profile__item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "Data urodzenia:", -1)
const _hoisted_9 = { class: "profile__item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "Typ wynagrodzenia:", -1)
const _hoisted_11 = { class: "profile__item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "Wynagrodzenie na umowie:", -1)
const _hoisted_13 = { class: "profile__item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Wykonywana praca", -1)
const _hoisted_15 = { class: "profile__item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", null, "Język, jakiego używasz to:", -1)

import TopBar from "@/components/TopBar.vue";
import { useUserInfo } from "@/store/userInfo";
// import BaseNotecard from "@/components/UI/BaseNotecard.vue";
import { IsSameCity, ProfileField, SalaryType } from "@/types/userInfo";
import { computed } from "vue";
import ProfileSet from "@/components/ProfileSet.vue";
import { useLangStore } from "@/store/lang";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const userInfoStore = useUserInfo();
const langStore = useLangStore();

const salaryType = computed(() => {
  let salaryTypeText = "";

  switch (userInfoStore.userInfo[ProfileField.SALARYTYPE].value) {
    case SalaryType.HOURLY:
      salaryTypeText = langStore.messages.salaryType.hourly;
      break;
    case SalaryType.MONTHLY:
      salaryTypeText = langStore.messages.salaryType.monthly;
      break;
    default:
      salaryTypeText = userInfoStore.userInfo[ProfileField.SALARYTYPE]
        .value as string;
  }
  return salaryTypeText;
});

const isSameCity = computed(() => {
  let sameCityText = "";

  if (userInfoStore.userInfo.issamecity.value === IsSameCity.NO) {
    sameCityText = "nie ";
  }
  return sameCityText;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(TopBar, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("figure", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("h1", null, _toDisplayString(_unref(userInfoStore).userInfo[_unref(ProfileField).NICKNAME].value), 1)
      ])
    ]),
    (_unref(userInfoStore).isProfileFinished)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _createElementVNode("article", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", null, _toDisplayString(_unref(userInfoStore).userBirthDate), 1)
          ]),
          _createElementVNode("article", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", null, _toDisplayString(_unref(salaryType)), 1)
          ]),
          _createElementVNode("article", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", null, _toDisplayString(_unref(userInfoStore).userInfo[_unref(ProfileField).SALARYAMOUNT].value) + " " + _toDisplayString(_unref(userInfoStore).userInfo[_unref(ProfileField).CURRENCY].value) + _toDisplayString(_unref(userInfoStore).userInfo[_unref(ProfileField).SALARYTYPE].value ===
            _unref(SalaryType).HOURLY
              ? "/h"
              : ""), 1)
          ]),
          _createElementVNode("article", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("p", null, _toDisplayString(_unref(isSameCity)) + "znajduje się w miejscu zamieszkania", 1)
          ]),
          _createElementVNode("article", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("p", null, _toDisplayString(_unref(langStore).getLangName), 1)
          ])
        ]))
      : (_openBlock(), _createBlock(ProfileSet, { key: 1 }))
  ]))
}
}

})